import { autoinject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { MooringOfferVersionDto } from 'models/mooring/MooringOffers';
import { MooringOfferService } from 'services/mooring';
import { AsyncErrorHandler } from 'lib/ui';
import { Router } from 'aurelia-router';

@autoinject
export class MooringOfferVersionsDialog {
  protected versions: MooringOfferVersionDto[] = [];
  protected offerId: number;
  protected loading = true;

  constructor(
    private dialogController: DialogController,
    private mooringOfferService: MooringOfferService,
    private router: Router
  ) {}

  async activate(params: { offerId: number }) {
    this.offerId = params.offerId;
    await this.loadVersions();
  }

  @AsyncErrorHandler
  async loadVersions() {
    this.loading = true;
    const { data } = await this.mooringOfferService.getVersions(this.offerId);
    this.versions = data;
    this.loading = false;
  }

  protected viewVersion(version: MooringOfferVersionDto) {
    if (version.IsActiveVersion) {
      // Navigate to active version in same window, close dialog
      this.dialogController.cancel();
      this.router.navigate(`mooring/offers/${version.Id}`);
    } else {
      // Open archived version in new window for read-only viewing
      const url = `${window.location.origin}/#/mooring/offers/${this.offerId}?versionId=${version.Id}&mooringId=${version.MooringId}`;
      window.open(url, '_blank');
    }
  }

  protected close() {
    this.dialogController.cancel();
  }
}
